/**
 * Canlan's primary ramp — WEB.
 *
 * Web and mobile deliberately ship DIFFERENT Canlan primaries (SN-8363).
 * Web uses the `#147efb` blue; mobile stays on the original `#004FFF`.
 * See `canlanPrimary.native.js` for the mobile half and the reasoning.
 *
 * Resolved by extension: webpack picks `.web.js`, Metro picks `.native.js`,
 * from the extensionless `./canlanPrimary` import in `appColors.js` — the
 * same seam already used by `env-handler` and `storage`.
 *
 * KNOWN GAP: `#147efb` is a mid-tone fill and misses the 4.5:1 WCAG AA floor
 * both ways — dark `#181d26` 4.35:1, white 3.88:1. `PRIMARY_TEXT` is dark as
 * the nearer of the two, not as a passing choice. The web primary needs to
 * move darker (taking white content) or lighter (taking dark) to pass.
 */
export const canlanPrimary = {
  PRIMARY: '#147efb',
  PRIMARY_LIGHT: '#4F9EFC',
  PRIMARY_HOVER: '#308DFB',
  PRIMARY_DARK: '#1067CE',
  // Dark, as the closer of two failing options — see KNOWN GAP above.
  PRIMARY_TEXT: '#181d26',
  DEFAULT_FLAIR: '#147efb',
  PROFILE_FLAG: '#147efb',
  WEB_INDICATOR: '#4F9EFC',
}

export default canlanPrimary
